import { render, staticRenderFns } from "./orderimport.vue?vue&type=template&id=438bdc72&scoped=true&"
import script from "./orderimport.vue?vue&type=script&lang=js&"
export * from "./orderimport.vue?vue&type=script&lang=js&"
import style0 from "./orderimport.vue?vue&type=style&index=0&id=438bdc72&lang=scss&scoped=true&"
import style1 from "./orderimport.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438bdc72",
  null
  
)

export default component.exports